//GeneratorFlag:[NoChange]
import Warehouse from './warehouse';
import WarehouseFilter from './warehouse-filter';

export default {Warehouse, WarehouseFilter}
export{Warehouse, WarehouseFilter}